<template>
    <data-iterator
        ref="iterator"
        :api="api"
        :filters.sync="filters"
        :fixed-filters="{ company: { exact: company } }"
    >
        <template v-slot:actions>
            <slot name="actions"></slot>
        </template>

        <template slot-scope="{ items }">
            <d-table
                :items="items"
                :headers="headers"
                :filters.sync="filters"
                row-select
                row-action
                @onRowSelected="onRowSelected"
            >
                <!-- name column -->
                <template v-slot:[`item.name`]="{ item }">
                    <router-link :to="getEditLink(item)">
                        {{ item.name }}
                    </router-link>
                </template>

                <!-- cutoff time -->
                <template v-slot:[`item.cutoffTime`]="{ item }">
                    {{ item.cutoffTime | transformDate }}
                </template>

                <!-- delivery at -->
                <template v-slot:[`item.deliveryTime`]="{ item }">
                    {{ item.deliveryTime | transformDate }} -
                    {{ item.deliveryTime | transformDate(30, true) }}
                </template>

                <!-- budget column -->
                <template v-slot:[`item.budgetLimit`]="{ item }">
                    {{ item.budgetLimit | currency }}
                </template>

                <!-- row actions -->
                <template v-slot:rowActions="{ item }">
                    <edit-button :to="getEditLink(item)"></edit-button>
                    <delete-action
                        :entity-name="item.name"
                        :entity-id="item.id"
                        :api="api"
                        @deleted="onEntityDeleted"
                        @failed="onEntityDeleteFailed"
                    ></delete-action>
                </template>
            </d-table>
        </template>

        <!-- batch actions -->
        <template v-slot:batchActions>
            <delete-batch-action
                :selected-ids="selectedIds"
                :api="api"
                @finished="onBatchDeleteFinished"
                @finishedWithErrors="onBatchDeleteFinishedWithErrors"
                @canceled="onBatchDeleteCanceled"
            ></delete-batch-action>
        </template>
    </data-iterator>
</template>

<script>
import RestApiType from '@/api/RestApiType'
import routeType from '@/router/routeType'
import RestApiCollection from '@/api/RestApiCollection'
import DataIteratorMixin from '@/components/mixins/DataIteratorMixin'
import DataTableMixin from '@/components/mixins/DataTableMixin'
import CloudcanteensHeaders from '@/pages/companies/mixins/CloudcanteensHeaders'

export default {
    mixins: [DataIteratorMixin, DataTableMixin, CloudcanteensHeaders],
    props: {
        companyId: {
            type: [String, Number],
            required: true,
        },
    },
    data() {
        return {
            api: RestApiType.COMPANY_CLOUDCANTEENS,
            filters: {
                order: {
                    deliveryTime: 'desc',
                },
            },
        }
    },
    computed: {
        company() {
            return RestApiCollection.get(RestApiType.COMPANIES).getItemIri(
                this.companyId
            )
        },
    },
    methods: {
        getEditLink(item) {
            return {
                name: routeType.COMPANY_CLOUDCANTEEN_EDIT,
                params: { companyId: this.companyId, cloudcanteenId: item.id },
            }
        },
    },
}
</script>
